import React from "react";
import DropdownSelect from "./DropdownSelect";

const DropDown = (props) => {
  const defaultSelectedOption = props.value
    ? props.options?.find((option) => option.value === props.value)
    : null;

  const defaultSelectedOptionMultiSelect = Array.isArray(props.value)
    ? props.options.filter((option) => props.value.includes(option.value))
    : [];

  return (
    <>
      <span className="d-inline-block custom-input">
        <DropdownSelect
          placeholder={props.placeholder}
          isMultiSelect={props.isMultiSelect}
          optionsValue={props.options}
          value={
            props.isMultiSelect
              ? defaultSelectedOptionMultiSelect
              : defaultSelectedOption
          }
          handleDropdownChange={props.onChange}
          handleDropdownBlur={props.onBlur}
          isDropdownDisabled={props.isDisabled}
          validationClass={props.validationClass}
        />
      </span>
    </>
  );
};

export default DropDown;
